import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import LogIn from "../components/LogIn";
import * as authActions from "./../../../../actions/auth.actions";
import * as commonActions from "./../../../../actions/common.actions";

class LogInContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillUnmount() {
    this.props.commonActions.showError(null);
  }

  handleSubmit(data) {
    this.props.authActions.login(data);
  }

  render() {
    return <LogIn onSubmit={this.handleSubmit} />;
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    authActions: bindActionCreators(authActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogInContainer);



// WEBPACK FOOTER //
// ./src/routes/common/logIn/containers/LogInContainer.js